// extracted by mini-css-extract-plugin
export default {"add-project-form-container":"AddProjectForm_add-project-form-container__VTAca","add-project-form-buttons-container":"AddProjectForm_add-project-form-buttons-container__ZjLTI"};